import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { isMobileView } from '../../../utils/general';
import RecipientInfo from '../../RecipientInfo';
import classes from '../ContactSellerDrawer/style.module.scss';
import SentHeader from './SentHeader';

const PopupHeader = ({ isSent, sentHeaderDisabled, drawerView }) => {
    const isMobile = isMobileView();
    const recipientInfoClass = classNames({ [classes.sellarInfo]: drawerView });
    const responseTimeClassName = classNames({ [classes.responseInfoDrawer]: drawerView });
    return isSent ? (
        <SentHeader disabled={sentHeaderDisabled}/>
    ) : (
        <RecipientInfo titleOnly={isMobile} messageSellerClassName={recipientInfoClass} responseTimeClassName={responseTimeClassName}/>
    );
};

PopupHeader.propTypes = {
    isSent: PropTypes.bool,
    drawerView: PropTypes.bool,
    sentHeaderDisabled: PropTypes.bool
};

export default PopupHeader;
